const o = {
  id: "NewYorkLotto",
  logo: !0,
  name: "New York Lotto",
  style: {
    colorPrimary: "#d31245",
    extraBall: {
      bg: "#d31245",
      color: "#ffffff"
    }
  }
};
export {
  o as default
};
